import React from "react";
import {
  UltravioletCaptureProperty,
  UltravioletFluorescenceCaptureProperty
} from "../../../Model/CaptureProfile";
import EOpticAndCameraFeature from "../../../Model/EOpticAndCameraFeature";
import { ToggleControl } from "../ImagerFeatureControls";

type CondenserControlProps = {
  disabled: boolean;
  captureProperty: UltravioletFluorescenceCaptureProperty | UltravioletCaptureProperty;
  onChange: (value: { illumination: boolean }) => void;
};

export function IlluminationControl({ captureProperty, disabled, onChange }: CondenserControlProps) {
  if (captureProperty.illumination == null) {
    throw new Error("Capture profile illumination is null");
  }

  return (
    <ToggleControl
      disabled={disabled}
      feature="Illumination"
      id={EOpticAndCameraFeature.Illumination}
      value={captureProperty.illumination}
      onValueChanged={(id, value) =>
        onChange({
          illumination: value,
        })
      }
    />
  );
}
